import React, { useState, useEffect } from 'react'
import resources from '../../../services'
import Btn from '../../../ui/Btn'
import { Field } from '../../../ui/Field'
import Select from 'react-select'
import moment from 'moment'
import CreatePage from '../../../composents/CreatePage'

const title = 'Water cards'
const headers = {
  icon: 'feather icon-plus',
  title: title,
  description: 'creation of new water card',
  breadcrumbs: [
    {
      title: title,
      link: '/water_cards/digi_cards',
    },
  ],
}

export default function CreateWaterCard() {
  const [loader, setLoader] = useState(false),
    [errors, setErrors] = useState({}),
    [user, setuser] = useState(),
    [users, setUsers] = useState(),
    [clients, setClients] = useState([]),
    [client, setClient] = useState(),
    [subcription, setSubcription] = useState(),
    [subscriptions, setSubcriptions] = useState([]),
    [permissions, setPermissions] = useState([]),
    [permission, setPermission] = useState(),
    cardTypes = [
      {
        value: 'RFID',
        label: 'RFID',
      },
      {
        value: 'QR Card',
        label: 'QR Card',
      },
    ],
    [cardType, setCardType] = useState({
      value: 'RFID',
      label: 'RFID',
    })

  async function onGet() {
    let cus = await resources.consumer
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (cus.status === 200) {
      let a = []
      cus.data.docs.forEach((el) => {
        a.push({
          value: el.id,
          label: el.surname + '(' + el.code + ')',
          client: el.client.id,
        })
      })
      setUsers(a)
    }

    let cit = await resources.subscription
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (cit.status === 200) {
      let a = []
      cit.data.docs.forEach((el) => {
        a.push({
          value: el.id,
          label: el.title,
          type: el.type,
          client: el.client?.id,
        })
      })
      setSubcriptions(a)
    }

    let ent = await resources.cardPermission
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (ent.status === 200) {
      let a = []

      ent.data.docs.forEach((el) => {
        a.push({
          value: el.id,
          label: el.title,
          client: el.client?.id,
        })
      })
      setPermissions(a)
    }
    let clientsFromApi = await resources.customer
      .read('all')
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (clientsFromApi.status === 200) {
      let covertaToLabelValue = []
      clientsFromApi.data.docs.forEach((el) => {
        covertaToLabelValue.push({
          value: el.id,
          label: el.name,
        })
      })
      setClients(covertaToLabelValue)
    }
  }

  useEffect(() => {
    onGet()
  }, [])

  /**
   * @param {React.FormEvent<HTMLFormElement>} e
   */
  async function onCreate(e) {
    e.preventDefault()
    let formData = new FormData(e.target)
    let object = {}
    formData.forEach((value, key) => (object[key] = value))
    if (client) object.client = client
    if (user) object.user = user.value
    if (subcription) object.subscription = subcription.value
    if (permission) object.cardPermission = permission.value
    if (cardType) object.cardType = cardType.value

    object.validityTo = moment(object.validityTo).format('DD-MM-YYYY')
    setLoader(true)
    setErrors({})
    let res = await resources.card
      .create(object)
      .then((responses) => {
        return responses
      })
      .catch((error) => {
        return Object.assign({}, error).response
      })
    if (res.status === 200) {
      sessionStorage.setItem('success', true)
      window.location.replace('/water_cards/digi_cards')
    } else if (res.status === 422) {
      setErrors(
        res.data.errors.reduce((acc, error) => {
          return { ...acc, [error.field]: error.message }
        }, {})
      )
    } else if (res.status === 403) {
      setErrors({ not_autorized: true })
    }
    setLoader(false)
  }

  const filterConsumer = () => {
    let all_cities = []
    if (client) {
      all_cities = users.filter((e) => e.client === client)
    }
    return all_cities
  }

  const filterPermission = () => {
    let all_cities = []
    if (client) {
      all_cities = permissions.filter((e) => e.client === client)
    }
    return all_cities
  }

  const filterSubscription = () => {
    let all_cities = []
    if (client) {
      all_cities = subscriptions.filter((e) => e.client === client)
    }
    return all_cities
  }

  return (
    <CreatePage show_error={errors['not_autorized']} headers={headers}>
      <form onSubmit={onCreate}>
        <div className="row justify-content-center mt-3 mb-3">
          <div className="col-lg-6 ">
            <div className="card">
              <div className="card-header">
                <h5>Information</h5>
              </div>
              <div className="card-body">
                <div className="mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Client name
                  </label>
                  <Select
                    onChange={(e) => {
                      if (e?.value) {
                        setClient(e.value)
                      } else {
                        setClient(null)
                      }
                      setSubcription(null)
                      setPermission(null)
                      setuser(null)
                    }}
                    options={clients}
                    isSearchable
                    isClearable
                    className={errors['client'] ? ' is-invalid' : ''}
                  />
                  {errors['client'] && <div className="invalid-feedback">{errors['client']}</div>}
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Consumer name
                  </label>
                  <Select
                    onChange={setuser}
                    options={filterConsumer()}
                    isSearchable
                    isClearable
                    value={user}
                    className={errors['user'] ? ' is-invalid' : ''}
                  />
                  {errors['user'] && <div className="invalid-feedback">{errors['user']}</div>}
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Permissions
                  </label>
                  <Select
                    onChange={setPermission}
                    options={filterPermission()}
                    isSearchable
                    isClearable
                    value={permission}
                    className={errors['cardPermission'] ? ' is-invalid' : ''}
                  />
                  {errors['cardPermission'] && (
                    <div className="invalid-feedback">{errors['cardPermission']}</div>
                  )}
                </div>

                <div className="form-group mb-3">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Card type <span style={{ color: 'red' }}>*</span>
                  </label>
                  <Select
                    onChange={(e) => setCardType(e)}
                    options={cardTypes}
                    isSearchable
                    value={cardType}
                    className={errors['cardType'] ? ' is-invalid' : ''}
                  />
                  {errors['cardType'] && (
                    <div className="invalid-feedback">{errors['cardType']}</div>
                  )}
                </div>

                <Field name="cardId" className="mb-3" error={errors['cardId']} required>
                  Card id
                </Field>

                <Field
                  name="validityTo"
                  className="mb-3"
                  error={errors['validityTo']}
                  type="date"
                  required
                >
                  card validity
                </Field>

                <Field
                  name="description"
                  type="textarea"
                  error={errors['description']}
                  className="mb-3"
                >
                  Note
                </Field>

                <div className="row ">
                  <div className="col-lg-12">
                    <div className="d-grid gap-2">
                      <Btn class="btn waves-effect waves-light btn-primary" onLoad={loader}>
                        <i className="feather icon-save"></i> Submit
                      </Btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </CreatePage>
  )
}
